import React, { Component } from 'react';
import { get } from 'lodash'

import { withChoosedCar } from '../../../shared/containers/containerChoosedCar'
import { withCarShortInfo } from '../../../shared/containers/containerCarShortInfo'
import ContentInner from '../../../shared/contentInner'
import FormItem from '../../../shared/items/static/formItem'
import FormItemsInline from '../../../shared/items/static/formItemsInline'
import SecondHeadTitle from '../../../shared/items/static/secondHeadTitle'
import DefaultLink from '../../../shared/items/static/defaultLink'
import getDates from '../../../shared/services/date.service'
import Preloader from './../../../shared/items/static/preloader'

import styles from './carShortInformation.module.scss'

class CarShortInformation extends Component {

  componentDidMount() {
    const { unitShortInfo, onGetCarShortInfo, choosedCarId } = this.props

    if (unitShortInfo.dataState !== 'STATE_READY' || unitShortInfo.carId !== choosedCarId)
      onGetCarShortInfo(choosedCarId)
  }

  componentDidUpdate(prevProps) {
    const { choosedCarId, onGetCarShortInfo } = this.props

    if (get(prevProps, ['choosedCarId'], null) !== choosedCarId)
      onGetCarShortInfo(choosedCarId)
  }

  render() {
    const { unitShortInfo, choosedCarId } = this.props
    const { drivers, unitBrand, unitModel, modelYear, registerNumber, maintenance } = unitShortInfo

    return (
      <div className={styles.carShortInformation}>
        <ContentInner>
          <SecondHeadTitle>
            <span>{drivers.length > 1 ? 'Водители' : 'Водитель'}</span>
          </SecondHeadTitle>

          {
            unitShortInfo.dataState === "STATE_READY"
              ? drivers.map((item, index) => {
                return (
                  <FormItemsInline gridCount={"2_4"} key={index}>

                    <FormItem title="ФИО">
                      <span>{`${item.firstName} ${item.lastName} ${item.middleName}`}</span>
                    </FormItem>
                    {
                      !!item.phone
                        ? <FormItem title="Контактный телефон">
                          <span>{item.phone}</span>
                        </FormItem>
                        : null
                    }
                    <FormItem title="Водительское удостоверение до">
                      <span>{getDates.getDateFormat2(item.licensePeriod)}</span>
                    </FormItem>
                    <FormItem title="Медицинаская справка до">
                      <span>{getDates.getDateFormat2(item.certificatePeriod)}</span>
                    </FormItem>

                  </FormItemsInline>
                )
              })
              : unitShortInfo.dataState !== "STATE_READY"
                ? <Preloader />
                : null
          }

          <div className={styles.container_moreCarShortInfo}>
            <DefaultLink link={`/car-info/ ${choosedCarId}`}>Подробнее</DefaultLink>
          </div>
        </ContentInner>

        <ContentInner>
          <SecondHeadTitle>
            <span>Свидетельство о регистрации</span>
          </SecondHeadTitle>

          {
            unitShortInfo.dataState === "STATE_READY"
              ? <FormItemsInline gridCount={"2_4"}>
                <FormItem title="Марка-модель">
                  <span>{`${unitBrand} ${unitModel}`}</span>
                </FormItem>
                <FormItem title="Регистрационный знак">
                  <span>{registerNumber}</span>
                </FormItem>
                <FormItem title="Год выпуска">
                  <span>{modelYear}</span>
                </FormItem>
              </FormItemsInline>
              : unitShortInfo.dataState !== "STATE_READY"
                ? <Preloader />
                : null
          }

          <div className={styles.container_moreCarShortInfo}>
            <DefaultLink link={`/car-info/ ${choosedCarId}`}>Подробнее</DefaultLink>
          </div>
        </ContentInner>

        <ContentInner>
          <SecondHeadTitle>
            <span>Техническое обслуживание</span>
          </SecondHeadTitle>
          {
            unitShortInfo.dataState === "STATE_READY"
              ? <FormItemsInline gridCount={"2_4"}>
                <FormItem title="Дата последнего тех. осмотра">
                  <span>{getDates.getDateFormat2(!!maintenance ? maintenance : null)}</span>
                </FormItem>
              </FormItemsInline>
              : unitShortInfo.dataState !== "STATE_READY"
                ? <Preloader />
                : null
          }

          <div className={styles.container_moreCarShortInfo}>
            <DefaultLink link={`/car-info/ ${choosedCarId}`}>Подробнее</DefaultLink>
          </div>
        </ContentInner>
      </div>
    )
  }
}

export default withChoosedCar(withCarShortInfo(CarShortInformation))